import type { Settings } from '@ais-ui/websockets';
import type { CollectionTranslator, VectorTileItem } from '../types';

/**
 * Translator for the `vector_tiles` collection. Maps the legacy blob's
 * top-level `vectorTiles[]` array to/from the clean, backend-aligned item shape.
 */
export const vectorTilesTranslator: CollectionTranslator<VectorTileItem> = {
  fromBlob(blob: Settings): VectorTileItem[] {
    const tiles = (blob as unknown as Record<string, unknown>).vectorTiles;
    if (!Array.isArray(tiles)) return [];
    return tiles.map((tile) => {
      const t = tile as Record<string, unknown>;
      return {
        id: String(t.id ?? ''),
        name: (t.name as string) ?? '',
        url: (t.url as string) ?? '',
        enabled: t.enabled !== false,
      };
    });
  },

  applyToBlob(blob: Settings, items: VectorTileItem[]): Settings {
    return {
      ...(blob as unknown as Record<string, unknown>),
      vectorTiles: items,
    } as unknown as Settings;
  },
};
